export const CircleCheck = () => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.99967 1.33398C4.31778 1.33398 1.33301 4.31875 1.33301 8.00065C1.33301 11.6825 4.31778 14.6673 7.99967 14.6673C11.6816 14.6673 14.6663 11.6825 14.6663 8.00065C14.6663 4.31875 11.6816 1.33398 7.99967 1.33398ZM10.3867 6.6506C10.5615 6.43688 10.53 6.12187 10.3163 5.94701C10.1026 5.77214 9.78756 5.80364 9.6127 6.01737L6.96256 9.25643L6.01989 8.31376C5.82463 8.1185 5.50805 8.1185 5.31279 8.31376C5.11753 8.50903 5.11753 8.82561 5.31279 9.02087L6.64612 10.3542C6.74601 10.4541 6.88349 10.5071 7.02458 10.5C7.16567 10.493 7.2972 10.4266 7.38665 10.3173L10.3867 6.6506Z"
      fill={"#225AEA"}
    />
  </svg>
)

export default CircleCheck
